import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import { createRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Cross, Search } from '@icons/index';

interface SearchComponentProps {
  placeholder?: string;
  handleChange?: (value: string) => void;
  value?: string;
  bgColor?: string;
  isCustom?: boolean;
}

const SearchComponent = (props: SearchComponentProps) => {
  const {
    handleChange,
    placeholder,
    value,
    bgColor = 'white',
    isCustom = false,
  } = props;

  const { t } = useTranslation();

  const inputRef = createRef<HTMLInputElement>();

  return (
    <Box>
      <TextField
        inputRef={inputRef}
        placeholder={placeholder || t('global.search')}
        value={value}
        color="secondary"
        sx={{
          '& .MuiInputBase-input ': {
            borderRadius: isCustom ? '4px' : 'none',
            fontSize: isCustom ? '14px' : '16px',
            paddingLeft: isCustom ? '10px' : 'inherit',
          },
        }}
        fullWidth
        InputProps={{
          style: { backgroundColor: bgColor },
          startAdornment: <Search width={isCustom ? 18 : 24} />,
          endAdornment: (
            isCustom ? null : <InputAdornment position="end">
              <IconButton onClick={() => {
                if (inputRef.current) inputRef.current.value = '';
                handleChange?.('');
              }}>
                <Cross style={{ transform: 'scale(1.5)' }} />
              </IconButton>
            </InputAdornment>
          ),
        }}
        onChange={(evt) => handleChange?.(evt.target.value)} />
    </Box>
  );
};

export default SearchComponent;
